import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ott-voucher',
  templateUrl: './ott-voucher.component.html',
  styleUrls: ['./ott-voucher.component.scss']
})
export class OttVoucherComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
